import { observable } from "mobx";
import "reflect-metadata";
import { EntityValidationRules } from "services/validationService";
import { IVehicle } from "./types";

export const LicensePlateValidationRules: EntityValidationRules<IVehicle> = {
  licensePlate: {
    hasRequiredLength: { min: 1, max: 10 },
    isLicensePlate: true,
  },
};

export const LicensePlateConfirmationValidationRules: EntityValidationRules<ChargeOrderLicenseItem> = {
  _licensePlateConfirmation: {
    equalWith: { property: "licensePlate" as const },
    hasRequiredLength: { min: 1, max: 10 },
    isLicensePlate: true,
  },
};

export const CountryIdValidationRules: EntityValidationRules<IVehicle> = {
  countryId: { required: "requiredCountryId" },
};

export default class ChargeOrderLicenseItem {
  @observable licensePlate?: string;

  @observable countryId?: string;

  @observable _licensePlateConfirmation?: string;

  @observable _showCountryWarning: boolean;

  constructor(
    licensePlate: string | undefined,
    _licensePlateConfirmation: string | undefined,
    countryId: string | undefined,
    showCountryWarning = false
  ) {
    this.licensePlate = licensePlate;
    this._licensePlateConfirmation = _licensePlateConfirmation;
    this.countryId = countryId;
    this._showCountryWarning = showCountryWarning;
  }
}

export const ChargeOrderLicenseItemValidationRules: EntityValidationRules<ChargeOrderLicenseItem> = {
  ...LicensePlateValidationRules,
  ...LicensePlateConfirmationValidationRules,
  ...CountryIdValidationRules,
};
